export default "/img/HR.3d3f2d9f3e6fb4e3e13bae3ad85228b7.png";